/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkExperienceContentRequest
 */
export interface WorkExperienceContentRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    clientCompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    clientCompanyId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    clientCompanyOrganizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkExperienceContentRequest
     */
    logoUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperienceContentRequest
     */
    currentJob: boolean;
    /**
     * 
     * @type {ActivityArea}
     * @memberof WorkExperienceContentRequest
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {Date}
     * @memberof WorkExperienceContentRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkExperienceContentRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {PostalAddress}
     * @memberof WorkExperienceContentRequest
     */
    location?: PostalAddress;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperienceContentRequest
     */
    asFreelancer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkExperienceContentRequest
     */
    imported?: boolean;
}

/**
 * Check if a given object implements the WorkExperienceContentRequest interface.
 */
export function instanceOfWorkExperienceContentRequest(value: object): value is WorkExperienceContentRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('clientCompanyName' in value) || value['clientCompanyName'] === undefined) return false;
    if (!('currentJob' in value) || value['currentJob'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('asFreelancer' in value) || value['asFreelancer'] === undefined) return false;
    return true;
}

export function WorkExperienceContentRequestFromJSON(json: any): WorkExperienceContentRequest {
    return WorkExperienceContentRequestFromJSONTyped(json, false);
}

export function WorkExperienceContentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkExperienceContentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'title': json['title'],
        'clientCompanyName': json['clientCompanyName'],
        'clientCompanyId': json['clientCompanyId'] == null ? undefined : json['clientCompanyId'],
        'clientCompanyOrganizationId': json['clientCompanyOrganizationId'] == null ? undefined : json['clientCompanyOrganizationId'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'currentJob': json['currentJob'],
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'startDate': (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'location': json['location'] == null ? undefined : PostalAddressFromJSON(json['location']),
        'asFreelancer': json['asFreelancer'],
        'imported': json['imported'] == null ? undefined : json['imported'],
    };
}

export function WorkExperienceContentRequestToJSON(value?: WorkExperienceContentRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'title': value['title'],
        'clientCompanyName': value['clientCompanyName'],
        'clientCompanyId': value['clientCompanyId'],
        'clientCompanyOrganizationId': value['clientCompanyOrganizationId'],
        'logoUrl': value['logoUrl'],
        'currentJob': value['currentJob'],
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'startDate': ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'location': PostalAddressToJSON(value['location']),
        'asFreelancer': value['asFreelancer'],
        'imported': value['imported'],
    };
}

